import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import axios from "axios";
import "swiper/css/bundle";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Testimonials({ className }) {
  const [testimonials, setTestimonials] = useState([]);
  const [expandedTestimonials, setExpandedTestimonials] = useState({});
  const [selectedTag, setSelectedTag] = useState("All");

  // Fetch data from the MySQL database
  useEffect(() => {
    axios
      .get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/testimonialssortnew") // Replace with your actual API URL
      .then((response) => {
        setTestimonials(response.data);
      })
      .catch((error) => {
        console.error("Error fetching testimonials:", error);
      });
  }, []);
  const [formData, setFormData] = useState({
    fullName: "",
    subject: "",
    email: "",
    contact: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = "Full name is required";
    if (!formData.subject) newErrors.subject = "Job Title is required";
    if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Valid email is required";
    if (!formData.contact || !/^\d{10}$/.test(formData.contact))
      newErrors.contact = "Valid 10-digit contact number required";
    if (!formData.message) newErrors.message = "Feedback is required";
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "contact") {
      // Allow only digits and limit to 10 characters
      const numericValue = value.replace(/\D/g, ""); // remove non-digits
      if (numericValue.length <= 10) {
        setFormData({ ...formData, [name]: numericValue });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setIsSubmitting(true); // Disable button
    try {
      await axios.post("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/submitreviewform", formData);
      toast.success("Thankyou for reviewing our services! Your feedback will soon be live after internal quality review.");
      setFormData({
        fullName: "",
        subject: "",
        email: "",
        contact: "",
        message: "",
      });
    } catch (err) {
      toast.error("Sorry! Some Error Occoured. Please try again later.");
    } finally {
    setIsSubmitting(false); // Re-enable button
  }
  };

  const toggleTestimonial = (id) => {
  setExpandedTestimonials((prev) => ({
    ...prev,
    [id]: !prev[id],
  }));
};

const shouldShowReadMore = (text) => {
  if (!text) return false;
  return text.length > 320;
};

const formatDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

// Create unique tag list from testimonials
const testimonialTags = [
  "All",
  ...Array.from(
    new Set(
      testimonials
        .map((item) => item.Tagname)
        .filter((tag) => tag && tag.trim() !== "")
        .map((tag) => tag.trim())
    )
  ),
];

// Filter testimonials according to selected tag
const filteredTestimonials =
  selectedTag === "All"
    ? testimonials
    : testimonials.filter(
        (item) =>
          item.Tagname &&
          item.Tagname.trim() === selectedTag
      );
return (
  <section className="feedback-section">
    <div className="wrap-testimonials over-flow-hidden">
      <div className="tf-container">

        {/* PAGE HEADING */}
        <div className="row">
          <div className="col-lg-12">
            <div className="tf-title style-2 feedback-heading">
              <div className="group-title">
                <span className="feedback-label">Customer Feedbacks</span>

                <h3 style={{ marginBottom: "8px", fontSize: "28px" }}>
                  Feel free to leave us a feedback!
                </h3>

                <p style={{ marginBottom: "0", fontSize: "15px" }}>
                 Your feedback helps us understand your experience and improve our services. Once submitted, scroll down to read real reviews shared by our customers.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CENTERED FORM */}
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-8 col-md-10 col-12">
            <div className="feedback-form-card">
           

              <form onSubmit={handleSubmit}>
                <div className="group-input feedback-input-row">
                  <div className="ip" style={{marginBottom: "12px"}}>
                    <input
                      type="text"
                      name="fullName"
                      placeholder="Full Name"
                      value={formData.fullName}
                      onChange={handleChange}
                    />
                    {errors.fullName && <small>{errors.fullName}</small>}
                  </div>

                  <div className="ip" style={{marginBottom: "12px"}}>
                    <input
                      type="text"
                      name="subject"
                      placeholder="Position / Job Title"
                      value={formData.subject}
                      onChange={handleChange}
                    />
                    {errors.subject && <small>{errors.subject}</small>}
                  </div>
                </div>

                <div className="group-input feedback-input-row">
                  <div className="ip" style={{marginBottom: "12px"}}>
                    <input
                      type="text"
                      name="email"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && <small>{errors.email}</small>}
                  </div>

                  <div className="ip" style={{marginBottom: "12px"}}>
                    <div className="phone-input-wrap">
                      <span>+91</span>
                      <input
                        type="text"
                        name="contact"
                        placeholder="Contact No."
                        value={formData.contact}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.contact && <small>{errors.contact}</small>}
                  </div>
                </div>

                <div className="ip out" style={{marginBottom: "12px"}}>
                  <textarea
                    name="message"
                    placeholder="Write your feedback here."
                    value={formData.message}
                    onChange={handleChange}
                  />
                  {errors.message && <small>{errors.message}</small>}
                </div>

                <div className="feedback-submit-wrap">
                  <button type="submit" disabled={isSubmitting}>
                    {isSubmitting ? "Please Wait..." : "Submit Feedback"}
                  </button>
                </div>
              </form>

              <style>
                {`
                  .Toastify__close-button {
                    display: none;
                  }

                  .Toastify__toast {
                    position: relative;
                    padding-right: 30px;
                  }
                `}
              </style>

              <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
            </div>
          </div>
        </div>

        {/* REVIEWS START AFTER FORM */}
        <div className="feedback-reviews-section">
          <div className="row">
            <div className="col-lg-12">
              <div className="feedback-review-heading">
                <span>Real Experiences</span>
                <h2>What People Say About Us</h2>
                <p>
                  A collection of experiences shared by our customers and learners.
                </p>
              </div>
            </div>
          </div>
{/* TESTIMONIAL TAG FILTERS */}
<div className="feedback-tag-filter">
  {testimonialTags.map((tag) => (
    <button
      key={tag}
      type="button"
      className={`feedback-tag-btn ${
        selectedTag === tag ? "active" : ""
      }`}
      onClick={() => {
        setSelectedTag(tag);
        setExpandedTestimonials({});
      }}
    >
      {tag}
    </button>
  ))}
</div>
          <div className="row">
            {filteredTestimonials.length > 0 ? (
  filteredTestimonials.map((item, index) => (
    <div
      className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12"
      key={item.Id || index}
      style={{ marginBottom: "14px" }}
    >
      <div
        className={`wd-testimonials feedback-card ${
          expandedTestimonials[item.Id || index]
            ? "card-expanded"
            : ""
        }`}
      >
        <div className="quote-icon">“</div>

        <p
          className={`description ${
            expandedTestimonials[item.Id || index]
              ? "expanded"
              : ""
          }`}
          style={{ paddingTop: "12px" }}
        >
          {item.Descriptions}
        </p>

        {shouldShowReadMore(item.Descriptions) && (
          <button
            type="button"
            className="read-more-btn"
            onClick={() =>
              toggleTestimonial(item.Id || index)
            }
          >
            {expandedTestimonials[item.Id || index]
              ? "Show less"
              : "Read more"}
          </button>
        )}

        <div className="author-group">
          <div className="infor">
            <h6>{item.Named}</h6>
            <div className="position">
              {item.Jobtitle} - {formatDate(item.CreatedAt)}
            </div>
          </div>
        </div>
      </div>
    </div>
  ))
) : (
  <div className="col-lg-12">
    <p
      style={{
        textAlign: "center",
        color: "#777",
        padding: "30px 0",
      }}
    >
      No feedbacks available yet.
    </p>
  </div>
)}
          </div>
        </div>

      </div>
    </div>

    <style>
      {`

.feedback-tag-filter {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 30px;
}

.feedback-tag-btn {
  border: 1px solid #dfe8e4;
  background: #ffffff;
  color: #555;
  border-radius: 999px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}

.feedback-tag-btn:hover {
  border-color: #14a077;
  color: #14a077;
  background: #f3fbf8;
}

.feedback-tag-btn.active {
  background: #14a077;
  border-color: #14a077;
  color: #ffffff;
  box-shadow: 0 5px 14px rgba(20, 160, 119, 0.20);
}

@media (max-width: 767px) {
  .feedback-tag-filter {
    gap: 8px;
    margin-bottom: 24px;
    padding: 0 8px;
  }

  .feedback-tag-btn {
    padding: 8px 14px;
    font-size: 12px;
  }
}


        .feedback-section {
          padding: 50px 0 70px;
          background: linear-gradient(180deg, #fffaf4 0%, #ffffff 100%);
        }

        .feedback-heading {
          text-align: center;
          margin-bottom: 35px;
        }

        .feedback-heading .group-title {
          max-width: 780px;
          margin: 0 auto;
        }

        .feedback-label {
          display: inline-block;
          padding: 6px 14px;
          border-radius: 999px;
          background: #fff3df;
          color: #b56b00;
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 12px;
        }

        .feedback-heading h1 {
          font-size: 34px;
          line-height: 1.25;
          margin-bottom: 12px;
          color: #1f2933;
        }

        .feedback-heading p {
          font-size: 15px;
          line-height: 1.7;
          color: #666;
          margin: 0 auto;
        }

        .feedback-form-card {
          background: #ffffff;
          border: 1px solid #f0e5d8;
          border-radius: 22px;
          padding: 30px;
          box-shadow: 0 14px 40px rgba(0, 0, 0, 0.07);
          margin-bottom: 55px;
        }

        .feedback-form-header {
          text-align: center;
          margin-bottom: 24px;
        }

        .feedback-form-header h6 {
          font-weight: 700;
          font-size: 22px;
          line-height: 1.35;
          margin-bottom: 8px;
          color: #1f2933;
        }

        .feedback-form-header p {
          margin: 0;
          font-weight: 400;
          font-size: 15px;
          line-height: 1.7;
          color: #666;
        }

        .feedback-form-card input,
        .feedback-form-card textarea {
          background: #f8f8f8 !important;
          color: #111 !important;
          border-radius: 12px !important;
          border: 1px solid #e9e2da !important;
        }

        .feedback-form-card input:focus,
        .feedback-form-card textarea:focus {
          border-color: #d29a45 !important;
          background: #ffffff !important;
        }

        .feedback-form-card small {
          color: #d93025;
          font-size: 12px;
          margin-top: 4px;
          display: block;
        }

        .feedback-input-row {
          gap: 15px;
        }

        .phone-input-wrap {
          position: relative;
          display: flex;
          align-items: center;
        }

        .phone-input-wrap span {
          position: absolute;
          left: 15px;
          color: #555;
          font-weight: 700;
          z-index: 2;
        }

        .phone-input-wrap input {
          padding-left: 55px !important;
        }

        .feedback-form-card textarea {
          min-height: 135px;
          resize: vertical;
        }

        .feedback-submit-wrap {
          display: flex;
          justify-content: center;
          margin-top: 8px;
        }

        .feedback-submit-wrap button {
          min-width: 210px;
          border: none;
          border-radius: 5px;
          padding: 13px 26px;
          background: #14a077;
          color: #ffffff;
          font-size: 15px;
          font-weight: 700;
          transition: all 0.25s ease;
        }

        .feedback-submit-wrap button:hover {
          background: #0d8462;
          transform: translateY(-2px);
        }

        .feedback-submit-wrap button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .feedback-reviews-section {
          margin-top: 10px;
        }

        .feedback-review-heading {
          text-align: center;
          margin-bottom: 30px;
        }

        .feedback-review-heading span {
          display: inline-block;
          font-size: 13px;
          font-weight: 700;
          color: #14a077;
          margin-bottom: 8px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .feedback-review-heading h2 {
          font-size: 30px;
          line-height: 1.25;
          color: #1f2933;
          margin-bottom: 8px;
        }

        .feedback-review-heading p {
          color: #666;
          font-size: 15px;
          margin: 0;
        }

       .feedback-card {
  position: relative;
  height: 100%;
  min-height: 310px;
  max-height: 310px;
  margin-bottom: 6px;
  padding: 26px 22px 22px;
  background: #ffffff;
  border: 1px solid #f1e7dc;
  border-radius: 20px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.055);
  transition: all 0.25s ease;
  overflow: hidden;

  display: flex;
  flex-direction: column;
}

.feedback-card.card-expanded {
  height: auto !important;
  max-height: none !important;
  min-height: 310px;
  overflow: visible !important;
}

        .feedback-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 18px 38px rgba(0, 0, 0, 0.09);
        }

        .feedback-card .quote-icon {
          position: absolute;
          top: 8px;
          right: 18px;
          font-size: 54px;
          line-height: 1;
          color: rgba(20, 160, 119, 0.12);
          font-family: Georgia, serif;
          font-weight: 700;
        }

      .feedback-card .description {
  font-size: 14px;
  line-height: 1.65;
  color: #444;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1;
}

.feedback-card .description.expanded {
  display: block !important;
  -webkit-line-clamp: unset !important;
  -webkit-box-orient: unset !important;
  overflow: visible !important;
  max-height: none !important;
  height: auto !important;
}

.read-more-btn {
  border: none;
  background: transparent;
  color: #14a077;
  font-size: 13px;
  font-weight: 700;
  padding: 0;
  margin-bottom: 14px;
  cursor: pointer;
  text-decoration: underline;
  align-self: flex-start;
  flex-shrink: 0;
}

.read-more-btn:hover {
  color: #0d8462;
}

        .feedback-card .author-group {
  border-top: 1px solid #f0e8df;
  padding-top: 14px;
  margin-top: auto;
  flex-shrink: 0;
}

        .feedback-card .infor h6 {
          font-size: 16px;
          font-weight: 700;
          color: #1f2933;
          margin-bottom: 3px;
        }

        .feedback-card .position {
          font-size: 13px;
          color: #777;
        }

        @media (max-width: 991px) {
          .feedback-heading h1 {
            font-size: 30px;
          }

          .feedback-form-card {
            padding: 24px;
          }
        }

        @media (max-width: 767px) {
          .feedback-section {
            padding: 35px 0 50px;
          }

          .feedback-heading {
            margin-bottom: 25px;
          }

          .feedback-heading h1 {
            font-size: 25px;
          }

          .feedback-heading p,
          .feedback-form-header p,
          .feedback-review-heading p {
            font-size: 14px;
          }

          .feedback-form-card {
            padding: 18px;
            border-radius: 18px;
            margin-bottom: 38px;
          }

          .feedback-form-header h6 {
            font-size: 20px;
          }

          .feedback-input-row {
            display: block;
          }

          .feedback-input-row .ip {
            width: 100%;
          }

          .feedback-submit-wrap button {
            width: 100%;
          }

          .feedback-review-heading h2 {
            font-size: 24px;
          }

        .feedback-card {
  min-height: 280px;
  max-height: 280px;
  margin-bottom: 18px;
}

.feedback-card.card-expanded {
  max-height: none !important;
  min-height: 280px;
}

       .feedback-card .description {
  -webkit-line-clamp: 6;
}

.feedback-card .description.expanded {
  display: block !important;
  -webkit-line-clamp: unset !important;
  -webkit-box-orient: unset !important;
  overflow: visible !important;
  max-height: none !important;
  height: auto !important;
}
        }
      `}
    </style>
  </section>
);
}

export default Testimonials;